import * as logger from '@mamdev/navigator.frontend-logger'
import { getStage } from './stage'

export const LOCAL_STORAGE_KEY_DEBUG = 'AUTH-INTERMEDIATE_DEBUG'

export function getLogLevel(): logger.LogLevel {
  if (window.localStorage.getItem(LOCAL_STORAGE_KEY_DEBUG)) {
    return logger.LogLevel.debug
  }

  switch (getStage()) {
    case 'dev':
      return logger.LogLevel.debug
    case 'qa':
      return logger.LogLevel.info
    case 'pre':
      return logger.LogLevel.warn
    case 'live':
      return logger.LogLevel.error
    default:
      return logger.LogLevel.error
  }
}
